import styled from 'styled-components';

export const ErrorMessage = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  background-color: #f8d7da;
  border-radius: 4px;
  padding: 8px;
  margin-bottom: 16px;
  border: 1px solid #f5c6cb;
  font-size: 14px;
  color: #721c24;
`;

export const FormErrorMessage = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  background-color: #f8d7da;
  border-radius: 4px;
  padding: 8px;
  border: 1px solid #f5c6cb;
  font-size: 14px;
  color: #721c24;
`;
